module.exports = __webpack_public_path__ + "img/99.4148fae8.jpg";